if (window.matchMedia("(max-width: 1100px)").matches) {
  $(".carousel").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    arrows: false,
    prevArrow: "<button class='previousArrow'><span>prev</span></button>",
    nextArrow: "<button class='nextArrow'><span>next</span></button>",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
}

document.addEventListener("alpine:initialized", function () {
  let askModelBtn = document.querySelector("#askModelBtn");
  let askModelCloseBtn = document.getElementById("closeModalBtn");
  let askModel = document.getElementById("customAskModal");
  let askModelBackdrop = document.getElementById("modalBackdrop");
  if (askModelBtn) {
    askModelBtn.onclick = function () {
      askModel.classList.add("show");
      askModel.style.display = "block";
      askModelBackdrop.classList.add("show");
      askModelBackdrop.style.display = "block";
    };
  }
  if (askModelCloseBtn) {
    askModelCloseBtn.onclick = function () {
      askModel.classList.remove("show");
      askModel.style.display = "none";
      askModelBackdrop.classList.remove("show");
      askModelBackdrop.style.display = "none";
    };
  }
  if (askModelBackdrop) {
    askModelBackdrop.onclick = function () {
      askModelCloseBtn.click();
    };
  }
});
